<template>
  <div class="dept">
    <el-input
      class="search-dept"
      prefix-icon="el-icon-search"
      v-model.trim="departmentName"
      @input="searchDep"
      size="small"
      placeholder="部门名称"
    />
    <el-tree
      class="tree-dept"
      ref="tree"
      :props="props"
      :data="deptTree"
      node-key="id"
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      highlight-current
      @node-click="nodeClick"
    >
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    deptTree: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    },
    defaultId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      props: {
        label: "name",
        children: "children"
      },
      departmentName: ""
    };
  },
  methods: {
    nodeClick(data) {
      this.$emit("select", data.id);
    },
    searchDep(val) {
      this.$refs.tree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.dept {
  .search-dept {
    font-size: 14px;
  }
  .tree-dept {
    margin-top: 20px;
    background-color: #f4f8fb;
    color: #51627d;
    font-size: 12px;
  }
}
</style>
